module.exports = __webpack_public_path__ + "img/onboarding-completed-overview-uae.8b4a3453.png";